import { productConfigTransformer } from '../google/index.js';
export const {
  hasPrice,
  transformProductConfig
} = productConfigTransformer;
export function getProductConfiguration(inventory, includeWalletData) {
  if (includeWalletData === void 0) {
    includeWalletData = false;
  }
  const {
    owner,
    accelerate,
    creditApp,
    isWestlakePrequal,
    fyuseId
  } = inventory;
  const {
    productConfiguration
  } = transformProductConfig({
    wallet: includeWalletData,
    homeServices: {
      ...owner?.homeServices,
      accelerate
    },
    shippingLabel: owner?.shippingLabel,
    nds: hasPrice(inventory),
    westlake: isWestlakePrequal,
    creditApp: creditApp || accelerate,
    vi360: !!fyuseId
  }, includeWalletData);
  return productConfiguration;
}
export default {
  transformProductConfig,
  hasPrice,
  getProductConfiguration
};